import { error } from '@ms/yammer-telemetry/dist/logging';
import loadPolyfills from '@ms/yammer-web-polyfills';

export default async () => {
  try {
    await loadPolyfills();
  } catch (err) {
    error('Failed to polyfill:', err);
  }
};
